import type { VaultApyRange } from '@/types/apy'
import type { Vault } from '@/types/vault'
import type { VaultsSortSchema } from '@/types/vaultsSortSchema'
import { sortVaults } from '@/utils/vaultsList/sortVaults'
import { useMemo } from 'react'

type SortedVaultsProps = {
  vaults: Vault[]
  apyRange: VaultApyRange
  includeRewards: boolean
} & VaultsSortSchema

export function useSortedVaults({ vaults, apyRange, includeRewards, sortBy, asc }: SortedVaultsProps) {
  return useMemo(
    () => sortVaults(vaults, apyRange, includeRewards, { sortBy, asc }),
    [vaults, apyRange, includeRewards, sortBy, asc]
  )
}
